import React from "react";

export default function Listing(props) {
  const { headers, headerLayout, dataSource, dataLayout, dataKeys, uniqueKey } =
    props;
  return (
    <div className="listing">
      <div
        className="header grid py-3 px-2 mb-2"
        style={{
          gridTemplateColumns: headerLayout,
          background: "#f3f3f3",
        }}
      >
        {headers.map((header) => {
          return <div className="font-weight-bolder">{header}</div>;
        })}
      </div>
      <div className="data grid px-2 gap-10">
        {dataSource.map((item) => {
          return (
            <div
              className={`table-rows grid items-center`}
              style={{ gridTemplateColumns: dataLayout }}
              key={item?.[uniqueKey]}
              // onClick={() => onRowClick(item)}
            >
              {dataKeys.map((renderBlock) => {
                if (typeof renderBlock === "object") {
                  if ("render" in renderBlock) {
                    // custom render function
                    return renderBlock?.render(item);
                  } else {
                    // default render statement
                    return <div>{item?.[renderBlock?.name]}</div>;
                  }
                } else {
                  return <div>{item?.[renderBlock]}</div>;
                }
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
